export default __webpack_public_path__ + "static/media/zero-touches-production.0a296ea1.svg";